import ReactDOM from "react-dom";
import React from "react";
import PostCarousel from "../components/post-carousel/PostCarousel";

class PostCarouselBlock {
  constructor(config) {
    this.el = config.el;
    this.mountPoint = this.el;

    // remove styles to prevent no-js styles from causing issues
    this.el.classList.remove("PostCarousel-list");
    const itemsString = this.el.getAttribute("data-carousel-items");
    // parse the string as JSON if it exists
    this.items = itemsString ? JSON.parse(itemsString) : "";

    if (this.items.length) {
      // Render the React Component
      ReactDOM.render(<PostCarousel items={this.items} />, this.mountPoint);
    }
  }
}

const init = () => {
  document.querySelectorAll("[data-carousel]").forEach(carousel => {
    new PostCarouselBlock({ el: carousel });
  });
};

// Init on initial page load
init();

